import { isNumber, toNumber } from "lodash-es";

export const RouteFactory = {
  home: "/",
  myBT: "/mybt",
  myBTOnboard: "/mybt/onboard",
  myBTIntro: "/mybt/intro",
  budget2024: "/singapore-budget-2024",
  keywordsBudget2024: "/keywords/singapore-budget-2024",
  keywordsBudget2025: "/keywords/singapore-budget-2025",
  keywordsBudget2026: "/keywords/singapore-budget-2026",
  article: (id: string) =>
    isNumber(toNumber(id)) ? `/article/${id}` : `/${id}`,
  section: (path: string) => `/${path}`,
  keywords: (keyword: string) => `/keywords/${keyword}`,
  search: "/search",
  authors: (uri: string) => `/authors/${uri}`,
  breakingNews: "/breaking-news",
  aboutUs: "/content/about-us",
  contactUs: "/content/contact-us",
  help: "/help",
  wealth: "/wealth",
  wealthSupplements: "/wealth/supplements",
  propertySupplements: "/property-supplements",
  globalEnterprise: "/international/global",
  globalEnterpriseLatest: "/international/global/latest",
  aseanBusiness: "/international/asean",
  aseanBusinessLatest: "/international/asean/latest",
  newsletterSignup: "/newsletters/sign-up",
  newsletterGarageArchivePage: "/newsletter/garage",
  thrive: "/thrive",
  thriveMoneyTalk: "/thrive/money-talk",
  thrivePersonalGrowth: "/thrive/personal-growth",
  thriveCareerGuide: "/thrive/career-guide",
  thriveAdulting: "/thrive/more-about-adulting",
  thriveEvents: "/thrive/events",
  thriveAboutUs: "/thrive/about-us",
  newsletterPropertyInsightArchivePage: "/newsletter/property",
  newsletterAseanBusinessArchivePage: "/newsletter/asean",
  newsletterEsgInsightsArchivePage: "/newsletter/esg",
  eventsAwards: "/events-awards",
  eventsAwardsNews: (awards: string) => `/events-awards/${awards}/news`,
  eventsAwardsWinners: (awards?: string) => `/events-awards/${awards}/winners`,
  eventsAwardsGallery: (awards?: string) => `/events-awards/${awards}/gallery`,
  eventsAwardsGalleryYear: (awards?: string, year?: string) =>
    `/events-awards/${awards}/gallery/${year}`,
  sgsme: "/singapore/smes",
  sgsmeLatest: "/singapore/smes/latest",
  lifestyle: "/lifestyle",
  lifestyleLuxe: "/lifestyle/bt-luxe",
  podcasts: "/podcasts",
  advertise: "/advertise",
  podcastsMoneyHacks: "/keywords/money-hacks",
  podcastsMarketFocus: "/keywords/market-focus",
  podcastsLensOn: "/keywords/lens-on",
  podcastsBTCorrespondents: "/keywords/bt-correspondents",
  podcastsBTPodcasts: "/keywords/bt-podcasts",
  faqPressRelease: "/pr/faq",
  esg: "/esg",
  rssFeeds: "/rss-feeds",
  videos: "/videos",
  videosDetailsPage: (slug: string, id: string) => `/videos/${slug}/${id}`,
  hub: "/hub",
  mbo: "/bt-mbo",
  asiaSquare: "/bt-mbo/asia-square",
  paidPressRelease: "/paid-press-release",
  pulse: "/pulse",
  pulseSlide: (articleId: string) => `/pulse/article/${articleId}`,
  newsletterUnsubscribe: "/bt_newsletter/unsubscribe",
  newsletterSubscribe: "/bt_newsletter/subscribe",
  newsletterUnsubscribeSuccess: "/unsubscription",
  myAccount: "/my-account",
  newsletters: "/newsletters",
  newslettersAseanBusiness: "/newsletters/asean-business",
  newslettersSgsme: "/newsletters/sgsme",
  newslettersDailyDebrief: "/newsletters/daily-debrief",
  newslettersBigMoney: "/newsletters/big-money",
  newslettersThrive: "/newsletters/thrive",
  newslettersBreakfastBrief: "/newsletters/breakfast-brief",
  newslettersLifestyle: "/newsletters/lifestyle",
  newslettersPropertyInsights: "/newsletters/property-insights",
  newslettersEsgInsights: "/newsletters/esg-insights",
  newslettersDaily: "/newsletters/daily",
  newslettersDecodingAsia: "/newsletters/sign-up/decoding-asia",
  keywordsSingaporeGe2025: "/keywords/ge2025",
  property: "/property",
  btsg60: "/keywords/bt-sg60",
  global: "/global",
  siaAboutPage: "/events-awards/sustainability-impact-awards/about",
  siaAwardsPage: "/events-awards/sustainability-impact-awards/awards",
  siaNominatePage:
    "/events-awards/sustainability-impact-awards/how-to-nominate",
  termsAndConditions: "/pr/t&c",
  siaContactUsPage: "/events-awards/sustainability-impact-awards/contact-us",
  siaPartnersPage: "/events-awards/sustainability-impact-awards/partners",
  siaJudgesPage: "/events-awards/sustainability-impact-awards/judges",
  sbaAboutPage: "/events-awards/singapore-business-awards/about",
  sbaAwardsPage: "/events-awards/singapore-business-awards/awards",
  sbaAwards: (awardType: string) =>
    `/events-awards/singapore-business-awards/awards/${awardType}`,
  sbaNominatePage: "/events-awards/singapore-business-awards/how-to-nominate",
  sbaContactUsPage: "/events-awards/singapore-business-awards/contact-us",
  zhHans: "/zh-hans",
  scaAboutPage: "/events-awards/singapore-corporate-awards/about",
  scaAwardsPage: "/events-awards/singapore-corporate-awards/awards",
  scaAwards: (awardType: string) =>
    `/events-awards/singapore-corporate-awards/awards/${awardType}`,
  scaNominatePage: "/events-awards/singapore-corporate-awards/how-to-apply",
  scaContactUsPage: "/events-awards/singapore-corporate-awards/contact-us",
  scaFaqPage: "/events-awards/singapore-corporate-awards/faq",
  scaPartnersPage: "/events-awards/singapore-corporate-awards/partners",
  e50AboutPage: "/events-awards/enterprise-50/about",
  e50AwardsPage: "/events-awards/enterprise-50/awards",
  e50NominatePage: "/events-awards/enterprise-50/how-to-apply",
  e50ContactUsPage: "/events-awards/enterprise-50/contact-us",
  e50FaqPage: "/events-awards/enterprise-50/faq",
  eeAboutPage: "/events-awards/emerging-enterprise/about",
  eeAwardsPage: "/events-awards/emerging-enterprise/awards",
  eeNominatePage: "/events-awards/emerging-enterprise/how-to-apply",
  eeApplyNowPage: "/events-awards/emerging-enterprise/apply-now",
  eeContactUsPage: "/events-awards/emerging-enterprise/contact-us",
  eeFaqPage: "/events-awards/emerging-enterprise/faq",
  eePartnersPage: "/events-awards/emerging-enterprise/partners",
  dtaAboutPage: "/events-awards/design-ai-and-tech-awards/about",
  dtaAwardsPage: "/events-awards/design-ai-and-tech-awards/awards",
  dtaNominatePage: "/events-awards/design-ai-and-tech-awards/how-to-nominate",
  dtaContactUsPage: "/events-awards/design-ai-and-tech-awards/contact-us",
  dtaJudgesPage: "/events-awards/design-ai-and-tech-awards/judges",
  dtaPartnersPage: "/events-awards/design-ai-and-tech-awards/partners",
};

export const isRouteCSROnly = function isRouteCSROnly(path: string): boolean {
  const staticRoutesRegexList = [new RegExp(`^.*${RouteFactory.search}.*`)];

  return staticRoutesRegexList.some((regex: RegExp) => regex.test(path));
};

export const routesVerticals = [
  RouteFactory.globalEnterprise,
  RouteFactory.aseanBusiness,
  RouteFactory.sgsme,
];

export const routesContentPages = [
  RouteFactory.help,
  RouteFactory.aboutUs,
  RouteFactory.contactUs,
  RouteFactory.advertise,
  RouteFactory.faqPressRelease,
  RouteFactory.rssFeeds,
];

export const routesToExcludeFromSection = [
  RouteFactory.keywords,
  RouteFactory.wealth,
  RouteFactory.lifestyle,
  RouteFactory.lifestyleLuxe,
  ...routesVerticals,
  RouteFactory.hub,
  ...routesContentPages,
  RouteFactory.newslettersDaily,
];

export const BT_PODCASTS_KEYWORD = [
  {
    url: RouteFactory.podcastsMoneyHacks,
    name: "Money Hacks",
  },
  {
    url: RouteFactory.podcastsLensOn,
    name: "Lens On",
  },
  {
    url: RouteFactory.podcastsMarketFocus,
    name: "Market Focus",
  },
  {
    url: RouteFactory.podcastsBTCorrespondents,
    name: "BT Correspondents",
  },
  {
    url: RouteFactory.podcastsBTPodcasts,
    name: "BT Podcasts",
  },
];

export const BT_CONTENT_PAGES = [
  {
    url: RouteFactory.help,
    name: "help",
  },
  {
    url: RouteFactory.faqPressRelease,
    name: "FAQ Press Release",
  },
  {
    url: RouteFactory.contactUs,
    name: "Contact Us",
  },
  {
    url: RouteFactory.aboutUs,
    name: "About Us",
  },
  {
    url: RouteFactory.advertise,
    name: "Advertise",
  },
  {
    url: RouteFactory.rssFeeds,
    name: "Rss Feeds",
  },
];

export const EVENTS_AWARDS_STATIC_ROUTES = [
  {
    url: RouteFactory.siaAboutPage,
    name: "Sia About",
  },
  {
    url: RouteFactory.siaNominatePage,
    name: "Sia Nominate",
  },
  {
    url: RouteFactory.siaAwardsPage,
    name: "Sia Awards",
  },
  {
    url: RouteFactory.siaContactUsPage,
    name: "Sia Contact Us",
  },
  {
    url: RouteFactory.siaPartnersPage,
    name: "Sia Partners",
  },
  {
    url: RouteFactory.siaJudgesPage,
    name: "Sia Judges",
  },
  {
    url: RouteFactory.sbaAboutPage,
    name: "Sba About",
  },
  {
    url: RouteFactory.sbaAwardsPage,
    name: "Sba Awards",
  },
  {
    url: RouteFactory.sbaNominatePage,
    name: "Sba Nominate",
  },
  {
    url: RouteFactory.sbaAwards(":awards"),
    name: "Sba Single Award",
  },
  {
    url: RouteFactory.sbaContactUsPage,
    name: "Sba Contact Us",
  },
  {
    url: RouteFactory.scaAboutPage,
    name: "Sca About",
  },
  {
    url: RouteFactory.scaAwardsPage,
    name: "Sca Awards",
  },
  {
    url: RouteFactory.scaNominatePage,
    name: "Sca Nominate",
  },
  {
    url: RouteFactory.scaAwards(":awards"),
    name: "Sca Single Award",
  },
  {
    url: RouteFactory.scaContactUsPage,
    name: "Sca Contact Us",
  },
  {
    url: RouteFactory.scaPartnersPage,
    name: "Sca Partners",
  },
  {
    url: RouteFactory.scaFaqPage,
    name: "Sca Faq",
  },
  {
    url: RouteFactory.eeAboutPage,
    name: "EE About",
  },
  {
    url: RouteFactory.eeNominatePage,
    name: "EE Nominate",
  },
  {
    url: RouteFactory.eeAwardsPage,
    name: "EE Awards",
  },
  {
    url: RouteFactory.eeContactUsPage,
    name: "EE Contact Us",
  },
  {
    url: RouteFactory.eeFaqPage,
    name: "EE Faq",
  },
  {
    url: RouteFactory.eeApplyNowPage,
    name: "EE Apply Now",
  },
  {
    url: RouteFactory.eePartnersPage,
    name: "EE Partners",
  },
  {
    url: RouteFactory.e50AboutPage,
    name: "E50 About",
  },
  {
    url: RouteFactory.e50NominatePage,
    name: "E50 Nominate",
  },
  {
    url: RouteFactory.e50AwardsPage,
    name: "E50 Awards",
  },
  {
    url: RouteFactory.e50ContactUsPage,
    name: "E50 Contact Us",
  },
  {
    url: RouteFactory.e50FaqPage,
    name: "E50 Faq",
  },
  {
    url: RouteFactory.dtaAboutPage,
    name: "Data About",
  },
  {
    url: RouteFactory.dtaAwardsPage,
    name: "Data Awards",
  },
  {
    url: RouteFactory.dtaNominatePage,
    name: "Data Nominate",
  },
  {
    url: RouteFactory.dtaContactUsPage,
    name: "Data Contact Us",
  },
  {
    url: RouteFactory.dtaJudgesPage,
    name: "Data Jydges",
  },
  {
    url: RouteFactory.dtaPartnersPage,
    name: "Data Partners",
  },
];
